var productName = 'schedulerpro';